export default {
  SUCCESS_MESSAGE_MODAL: 'SUCCESS_MESSAGE_MODAL',
  ERROR_MESSAGE_MODAL: 'ERROR_MESSAGE_MODAL',
  CLOSE_MESSAGE_MODAL: 'CLOSE_MESSAGE_MODAL'
}
